'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	title: 'Bad Permissions',
	message:
		"Sorry, you don't have the permissions to access this page. Please check you are logged in as the correct user.",
	image: 'modal-warning'
});
